import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import { ProjectsUpsellRequestSources } from '../constants'

interface UpsellProjectSpendingMessageProps {
  hasExpenses: boolean
}

export const UpsellProjectSpendingMessage = ({
  hasExpenses: _hasExpenses,
}: UpsellProjectSpendingMessageProps) => {
  const upsellMessage = i18n.t('project_management.upselling.spending')

  return (
    <UpsellingKit.EmptyState
      moduleRequested={AvailableModules.projects}
      featureRequested={Features.projects_costs}
      requestReason={ValidReasons.UpgradeFromLegacy}
      requestSource={ProjectsUpsellRequestSources.spending}
      title={i18n.t('project_management.upselling.title')}
      description={upsellMessage}
      buttonLabel={i18n.t('project_management.upselling.cta')}
      variant="table"
    />
  )
}
